const keywordTags = [
  "官方处罚",
  "内容下架",
  "监管质疑",
  "审核黑幕",
  "算法调整",
  "平台风波",
];

const liveStats = [
  { value: "128", label: "追踪议题" },
  { value: "4.6万", label: "社区讨论" },
  { value: "32", label: "处罚案例索引" },
];

export default function Hero() {
  return (
    <section id="tracking" className="w-full overflow-hidden bg-background-50">
      <div className="mx-auto grid w-full grid-cols-1 items-center gap-8 px-4 pb-12 pt-8 md:px-6 lg:grid-cols-2 lg:gap-12 lg:pt-14">
        {/* 左：文案对开 */}
        <div className="flex flex-col items-start">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
            <span className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-accent-400 text-background-50">
              <i className="ri-flashlight-fill text-[11px]" />
            </span>
            平台风波追踪 · 讨论社区
          </span>

          <h1 className="mt-5 font-heading text-3xl font-black leading-tight tracking-tight text-foreground-950 md:text-[40px] md:leading-[1.15]">
            快手黑料
            <span className="mt-2 block text-foreground-700">平台级争议，不止于八卦</span>
          </h1>

          <p className="mt-4 max-w-xl text-[15px] leading-relaxed text-foreground-700">
            聚焦快手平台层面的官方处罚、内容下架与监管质疑。我们不追个人八卦，只整理审核机制与算法调整背后的公开讨论——
            把各平台公告、创作者回应、网友举证聚到一处，帮你拼出「事件全貌」与「各方说法」。
          </p>

          <div className="mt-5 flex flex-wrap gap-2">
            {keywordTags.map((t) => (
              <span
                key={t}
                className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-background-200 bg-background-100 px-3 py-1 text-xs text-foreground-600"
              >
                <i className="ri-price-tag-3-line text-primary-500" />
                {t}
              </span>
            ))}
          </div>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#hot"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-community-line text-base" />
              进入热议区围观
            </a>
            <a
              href="#timeline"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-foreground-200 bg-background-50 px-5 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:bg-secondary-50"
            >
              只看事件时间线
              <i className="ri-arrow-right-line text-base" />
            </a>
          </div>

          <dl className="mt-8 grid w-full max-w-xl grid-cols-3 gap-px overflow-hidden rounded-xl border border-background-200 bg-background-200">
            {liveStats.map((s) => (
              <div key={s.label} className="flex flex-col gap-1 bg-background-50 px-4 py-3">
                <dt className="order-2 text-xs text-foreground-500">{s.label}</dt>
                <dd className="order-1 font-heading text-xl font-bold text-foreground-950">{s.value}</dd>
              </div>
            ))}
          </dl>
        </div>

        {/* 右：封面大图对开 */}
        <div className="relative flex items-start justify-center lg:justify-end">
          <div className="relative w-full max-w-[520px] overflow-hidden rounded-2xl border border-background-200 bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=Editorial%20newsroom%20collage%20about%20short%20video%20platform%20regulation%20and%20content%20moderation%2C%20stacked%20phone%20screens%20and%20newspaper%20clippings%20in%20warm%20beige%20tones%20with%20deep%20red%20accents%2C%20clean%20minimal%20composition%2C%20soft%20studio%20lighting%2C%20abstract%20documentary%20mood%2C%20no%20real%20people%20faces%2C%20high%20detail%2C%20artistic%20flat%20lay&width=900&height=1100&seq=hero-cover-ks-01&orientation=portrait"
              alt="快手黑料平台风波追踪封面图"
              className="h-[360px] w-full object-cover object-top sm:h-[440px] lg:h-[520px]"
            />
            <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent p-4 pt-16">
              <p className="font-heading text-lg font-bold text-background-50">「公告背后，算法与规则的暗流」</p>
              <p className="mt-1 text-xs text-background-50/80">审核机制调整如何影响你我看到的内容 — 本期深度追踪</p>
            </div>
            <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
              <i className="ri-live-line" /> 正在追踪
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}